import { YesNoUnknownEnum } from '@dermloop/static-values';
import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { SkinTypeDto } from '../clinical-details';
import { UserDto } from '../user.dto';

export class CreatePatientDetailsDto {
  @IsOptional()
  @IsBoolean()
  pregnancyWithinLast6Months?: boolean;

  @IsOptional()
  @IsBoolean()
  formerSkinCancer?: boolean;

  @IsOptional()
  @IsBoolean()
  formerMelanoma?: boolean;

  @IsOptional()
  @IsBoolean()
  formerCarcinoma?: boolean;

  @IsOptional()
  @IsString()
  otherFormerSkinCancer?: string;

  @IsOptional()
  @IsBoolean()
  familyHistoryOfMelanoma?: boolean;

  @IsOptional()
  @IsBoolean()
  hasRiskFactors?: boolean;

  @IsOptional()
  @IsString({ each: true })
  riskFactors?: string[];

  @IsOptional()
  @IsString()
  otherRisks?: string;

  @IsOptional()
  @IsBoolean()
  hasObjectiveFindings?: boolean;

  @IsOptional()
  @IsString({ each: true })
  objectiveFindings?: string[];

  @IsOptional()
  @IsString()
  otherObjectiveFindings?: string;

  @IsUUID('all')
  @IsNotEmpty()
  healthRecordId: string;

  @Type(() => SkinTypeDto)
  @IsOptional()
  @ValidateNested()
  skinType?: SkinTypeDto;

  @IsOptional()
  @IsString()
  skinTypeId?: string;

  @IsOptional()
  @IsEnum(YesNoUnknownEnum)
  hasImmunoSuppressantUse?: YesNoUnknownEnum;

  @IsOptional()
  @IsString()
  otherImmunoSuppressantUse?: string;
}

export class UpdatePatientDetailsDto {
  created?: string;

  @IsOptional()
  @IsBoolean()
  pregnancyWithinLast6Months?: boolean;

  @IsOptional()
  @IsBoolean()
  formerSkinCancer?: boolean;

  @IsOptional()
  @IsBoolean()
  formerMelanoma?: boolean;

  @IsOptional()
  @IsBoolean()
  formerCarcinoma?: boolean;

  @IsOptional()
  @IsString()
  otherFormerSkinCancer?: string;

  @IsOptional()
  @IsBoolean()
  familyHistoryOfMelanoma?: boolean;

  @IsOptional()
  @IsBoolean()
  hasRiskFactors?: boolean;

  @IsOptional()
  @IsString({ each: true })
  riskFactors?: string[];

  @IsOptional()
  @IsString()
  otherRisks?: string;

  @IsOptional()
  @IsBoolean()
  hasObjectiveFindings?: boolean;

  @IsOptional()
  @IsString({ each: true })
  objectiveFindings?: string[];

  @IsOptional()
  @IsString()
  otherObjectiveFindings?: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  medicalUnitId?: string;

  @IsNotEmpty()
  @IsUUID('all')
  healthRecordId?: string;

  @Type(() => SkinTypeDto)
  @IsOptional()
  @ValidateNested()
  skinType?: SkinTypeDto;

  @IsOptional()
  @IsUUID('all')
  skinTypeId?: string;

  @IsOptional()
  @IsEnum(YesNoUnknownEnum)
  hasImmunoSuppressantUse?: YesNoUnknownEnum;

  @IsOptional()
  @IsString()
  otherImmunoSuppressantUse?: string;
}

export class PatientDetailsDto {
  id: string;
  createdByUser?: UserDto;
  updatedByUser?: UserDto;
  deletedByUser?: UserDto;
  created?: string;
  updated?: string;
  deleted?: string;

  @IsOptional()
  @IsBoolean()
  pregnancyWithinLast6Months?: boolean;

  @IsOptional()
  @IsBoolean()
  formerSkinCancer?: boolean;

  @IsOptional()
  @IsBoolean()
  formerMelanoma?: boolean;

  @IsOptional()
  @IsBoolean()
  formerCarcinoma?: boolean;

  @IsOptional()
  @IsString()
  otherFormerSkinCancer?: string;

  @IsOptional()
  @IsBoolean()
  familyHistoryOfMelanoma?: boolean;

  @IsOptional()
  @IsBoolean()
  hasRiskFactors?: boolean;

  @IsOptional()
  @IsString({ each: true })
  riskFactors?: string[];

  @IsOptional()
  @IsString()
  otherRisks?: string;

  @IsOptional()
  @IsBoolean()
  hasObjectiveFindings?: boolean;

  @IsOptional()
  @IsString({ each: true })
  objectiveFindings?: string[];

  @IsOptional()
  @IsString()
  otherObjectiveFindings?: string;

  @IsString()
  @IsNotEmpty()
  medicalUnitId: string;

  @IsUUID('all')
  @IsNotEmpty()
  healthRecordId: string;

  @Type(() => SkinTypeDto)
  @IsNotEmpty()
  @IsOptional()
  skinType?: SkinTypeDto;

  @IsString()
  @IsNotEmpty()
  skinTypeId?: string;

  @IsOptional()
  @IsEnum(YesNoUnknownEnum)
  hasImmunoSuppressantUse?: YesNoUnknownEnum;

  @IsOptional()
  @IsString()
  otherImmunoSuppressantUse?: string;
}
